import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import useApi from "hooks/useApi";
import moment from "moment";
import { useEffect, useState } from "react";

const ActivityTable = ({ user_id }) => {
  const [allActivity, setAllActivity] = useState([]);
  const [reload, setReload] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 30,
    to: 0,
    from: 0,
    total: 0,
  });

  const { loading, fetchData } = useApi();
  useEffect(() => {
    const getActivitys = async () => {
      let finalPagination = { ...pagination };
      const params = `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}`;
      const endpoint = {
        method: "get",
        url: `/api/admin/staff/activity/${user_id}?${params}`,
      };
      const result = await fetchData(endpoint, false);
      if (result.success) {
        const { data: allData, ...rest } = result.data;
        setAllActivity(allData || []);
        setPagination(rest);
      }
    };
    getActivitys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, pagination?.current_page, pagination?.per_page]);

  const columns = [
    { id: "created_at", label: "Created at", style: { width: "170px" } },
    { id: "title", label: "Title" },
    { id: "description", label: "Description" },
  ];

  return (
    <Box sx={{ m: "-20px" }}>
      <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
        {!loading ? (
          <TableContainer
            sx={{ height: "calc(100vh - 188px)", overflowX: "auto" }}
          >
            <Table
              stickyHeader
              sx={{
                "& th:first-of-type": { pl: "20px", pr: "0px" },
                "& th:last-child": { pr: "20px" },
                "& td:first-of-type": { pl: "20px", pr: "0px" },
                "& td:last-child": { pr: "20px" },
              }}
            >
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, ...column.style }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allActivity?.map((row) => (
                  <TableRow hover role="checkbox" key={row.id}>
                    {columns.map((column, i) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.id === "created_at"
                            ? moment(value).format("lll")
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableSkeleton columns={columns} tableHeight="calc(100vh - 188px)" />
        )}
        <TablePagination
          span={columns?.length}
          setReload={setReload}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Paper>
    </Box>
  );
};

export default ActivityTable;
